@import (reference) '../../../../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

.item-name-container {
  gap: @space-4;
}

.item-name {
  .paragraph();
  text-align: left;
  word-break: break-word;
}

.base-sku {
  .caption();
  word-break: break-word;
}

.item-sku {
  .base-sku();
  margin-right: @space-8;
  color: var(--table-cell--subtext--text-color);
}

.item-sku-with-order-number {
  .base-sku();
  color: var(--table-cell--subtext--text-color);
  display: flex;
  flex-flow: row wrap;
}

.order-number {
  font-style: italic;
  font-weight: 500;
  color: var(--default--text-color--16);
}

.order-number-link {
  text-align: start;
  word-break: break-word;
}

.item-bundle-sku {
  .base-sku();
}
